import { CUSTOMER_REVIEW_ROUTE_NAME } from '@/libs/route-name';

export const customerReviewRoute = () => {
  return {
    name: CUSTOMER_REVIEW_ROUTE_NAME.CUSTOMER_REVIEW,
    path: 'customer-review',
    component: () => import('@/pages/customer-review/index.vue'),
    // meta: { onlyGuest: false }
  };
};
